export default __webpack_public_path__ + "static/media/hero2.d67cdbc8.webp";